import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_lg_circle",
  "use": "icon-home_lg_circle-usage",
  "viewBox": "0 0 212 212",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 212 212\" id=\"icon-home_lg_circle\">\n    <circle cx=\"106\" cy=\"106\" r=\"105.58\" fill=\"#F39801\" stroke=\"#F39801\" stroke-width=\".841\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol